// src/components/landing/StatsSection.jsx
import React, { useRef } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { motion, useInView } from 'framer-motion';
import { useCountUp } from './useCountUp';

const STATS = [
  { end: 150, suffix: '+', label: 'Training Institutions' },
  { end: 300, suffix: '+', label: 'Expert Faculties' },
  { end: 14,  suffix: '',  label: 'Districts Covered' },
  { end: 5000, suffix: '+', label: 'Students Trained' },
];

function StatBox({ end, suffix, label, isVisible }) {
  const count = useCountUp(end, 1800, isVisible);
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography sx={{ fontSize: { xs: '2.4rem', md: '3.2rem' }, fontWeight: 900, lineHeight: 1, color: '#fff' }}>
        {count.toLocaleString()}<Box component="span" sx={{ color: '#bae6fd' }}>{suffix}</Box>
      </Typography>
      <Typography sx={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', mt: 1 }}>{label}</Typography>
    </Box>
  );
}

export default function StatsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <Box
      ref={ref}
      sx={{
        background: 'linear-gradient(135deg,#1d4ed8 0%,#1d6cf0 40%,#0ea5e9 100%)',
        py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 },
        position: 'relative', overflow: 'hidden',
        '&::before': {
          content: '""', position: 'absolute', inset: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E")`,
        },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 7, position: 'relative', zIndex: 1 }}>
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: 'rgba(255,255,255,0.65)', mb: 1.5 }}>
          Impact
        </Typography>
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.4rem' }, fontWeight: 900, color: '#fff' }}>
          Our Mission by the Numbers
        </Typography>
      </Box>
      <Grid container spacing={4} sx={{ maxWidth: 900, mx: 'auto', position: 'relative', zIndex: 1 }}>
        {STATS.map((s, i) => (
          <Grid item xs={6} md={3} key={s.label}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.12 }}
            >
              <StatBox end={s.end} suffix={s.suffix} label={s.label} isVisible={isInView} />
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
